import { useAppSelector } from "../../../redux/hooks";
import { useFetch } from "../../../hooks/api";

import useDSPSellerInfo from "./useDSPSellerInfo";

export const useDSPIabCategories = (searchFilter, additionalParams) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const { dspAdvertiser } = useDSPSellerInfo();

  const { data, isLoading } = useFetch(
    ["dspIabCategories", additionalParams.inventoryType, dspAdvertiser?.id],
    "/dsp/iab_content_categories",
    {
      marketplace: marketPlace,
      nextToken: null,
      maxResults: 1000,
      dsp_seller_info_id: dspAdvertiser?.id,
      ...additionalParams,
    },
    {
      select: (res) => {
        const categoryLookup = res.data.iabContentCategories.reduce((acc, cat) => {
          return { ...acc, [cat.id]: cat };
        }, {});

        const formattedData =
          res.data.iabContentCategories?.map((category) => {
            return {
              ...category,
              parentDisplayName: categoryLookup[category.parentId]?.name,
            };
          }) ?? [];

        return formattedData;
      },
      default: [],
      staleTime: 60 * 5 * 1000,
    },
  );

  return { data, isLoading };
};
